// extracted by mini-css-extract-plugin
module.exports = {"container":"SessionForm_container__3D7Qe","blocks":"SessionForm_blocks__Y4OYX"};